/**
 * Access token fresco para o BFF (userinfo / JWT).
 * O SDK React 2.x entrega os callbacks como segundo argumento
 * (`getAccessTokenSilently(options, { cacheMode })`); sem ele o SDK usa o
 * cache padrão e serve token-fonte sem refresh.
 */
export async function getAccountAccessToken(
  getAccessTokenSilently: (
    options?: { authorizationParams?: Record<string, unknown> },
    callbacks?: { cacheMode?: 'on' | 'off' | 'cache-only' },
  ) => Promise<string>,
): Promise<string> {
  try {
    return await getAccessTokenSilently({}, { cacheMode: 'cache-only' })
  } catch {
    return getAccessTokenSilently({}, { cacheMode: 'on' })
  }
}
